import { AlbumManager } from '../models/AlbumManager';

const ALPHANUMERIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const KEY_LENGTH = 5;
const MAX_RETRIES = 10;

/**
 * Generates a random 5-character alphanumeric string (A-Z, 0-9)
 */
function generateRandomKey(): string {
  const array = new Uint8Array(KEY_LENGTH);
  crypto.getRandomValues(array);
  
  let key = '';
  for (let i = 0; i < KEY_LENGTH; i++) {
    key += ALPHANUMERIC_CHARS[array[i] % ALPHANUMERIC_CHARS.length];
  }
  
  return key;
}

/**
 * Generates a unique 5-character alphanumeric album key.
 * Checks for collisions and retries up to MAX_RETRIES times.
 * 
 * @returns Promise<string> A unique 5-character alphanumeric album key
 * @throws Error if unable to generate unique key after maximum retries
 */
export async function generateAlbumKey(): Promise<string> {
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    const candidateKey = generateRandomKey();
    
    // Check if this key already exists
    const existing = await AlbumManager.getAlbum(candidateKey);
    
    if (existing === null) {
      // Key is unique, return it
      return candidateKey;
    }
    
    // Collision detected, will retry
  }
  
  // All retries exhausted
  throw new Error('Unable to generate unique album key after maximum retries');
}
